import React from "react";
import "./HistoricalSection.scss";

const HistoricalSection = ({
  title,
  subtitle,
  cardTitle,
  cardSubtitle,
  image,
  description,
}) => {
  return (
    <section className="heritage" id="CulturalHeritage">
      <div className="heritage__header">
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>

      <div className="heritage__content">
        <div className="heritage__card">
          <img src={image} alt="heritage" />

          <div className="heritage__overlay">
            <h3>{cardTitle}</h3>
            <span>{cardSubtitle}</span>
          </div>
        </div>

        <div className="heritage__text">
          <p className="aboutSection__description">{description}</p>
        </div>
      </div>
    </section>
  );
};

export default HistoricalSection;
